'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';
import uiRouterExtensions from '../components/ui-router/index.js';
import uiBootstrap from 'angular-ui-bootstrap';
import ngValidationMatch from 'angular-validation-match';

import {
  routeConfig
} from './app.config.js';

// pages
import pages from './pages/index.js';
import _AuthSvc from '../components/auth/auth.module.js';
import _UserSvc from '../components/services/user.service.js';
import _OauthSvc from '../components/services/oauth.service.js';
import _GroupSvc from '../components/services/group.service.js';
import _GrpRoleTypeSvc from '../components/services/grpRoleType.service.js';
import _GrpRoleSvc from '../components/services/grpRole.service.js';
import _GrpTypeSvc from '../components/services/grpType.service.js';
import _GrpFeeSvc from '../components/services/groupFee.service.js';
import _GrpTxnSvc from '../components/services/groupTransaction.service.js';
import _GrpFinTxnSvc from '../components/services/financialTransaction.service.js'; // eslint-disable-line max-len
import _MemTypeSvc from '../components/services/memType.service.js';
import _MemberSvc from '../components/services/member.service.js';
import _PositionTypeSvc from '../components/services/positionType.service.js';
import _PositionSvc from '../components/services/position.service.js';
import _GrpAtrTypeSvc from '../components/services/groupAttributeType.service.js'; // eslint-disable-line max-len
import _GrpAtrSvc from '../components/services/groupAttribute.service.js';
import _MemAtrTypeSvc from '../components/services/memberAttributeType.service.js'; // eslint-disable-line max-len
import _MemAtrSvc from '../components/services/memberAttribute.service.js';
import _MemFeeSvc from '../components/services/memberFee.service.js';
import _MemTxnSvc from '../components/services/memberTransaction.service.js';

// app
import main from './main/main.component.js';
import account from './account/index.js';
import accountoauth from './accountoauth/index.js';
import user from './user/index.js';
import stripeRedirect from './stripeRedirect/index.js';
import admin from './admin/index.js';
import group from './group/index.js';
import grpRole from './grpRole/index.js';
import groupFee from './groupFee/index.js';
import groupTransaction from './groupTransaction/index.js';
import memType from './memType/index.js';
import member from './member/index.js';
import positionType from './positionType/index.js';
import position from './position/index.js';
import groupAttributeType from './groupAttributeType/index.js';
import memberAttributeType from './memberAttributeType/index.js';
import memberFee from './memberFee/index.js';
import memberTransaction from './memberTransaction/index.js';
import financialTransaction from './financialTransaction/index.js';

// components
import navbar from '../components/navbar/navbar.component.js';
import sidenav from '../components/sidenav/sidenav.component.js';
import footer from '../components/footer/footer.component.js';
import datetime from '../components/datetime/datetime.component.js'; // eslint-disable-line max-len
import fileSave from '../components/fileSave/fileSave.component.js'; // eslint-disable-line max-len
import list from '../components/list/index.js';
import form from '../components/form/index.js';
import modal from '../components/modal/index.js';
import util from '../components/util/util.module.js';
import ToastrSvc from '../components/toastr/toastr.module.js';
import stripe from '../components/stripe/stripe.module.js';

// loader component (requires ngActivityIndicator)
import ngActivityIndicator from '../components/loader/ngActivityIndicator.js';
import loader from '../components/loader/loader.component.js';

// constants
import constants from './app.constants.js';

// css
import './app.scss';

angular.module('georgeApp', [ngCookies, ngResource, ngSanitize, uiRouter,
  uiRouterExtensions, uiBootstrap, ngValidationMatch,
  pages,
  _AuthSvc,
  _UserSvc, _OauthSvc, _GroupSvc, _GrpRoleTypeSvc, _GrpRoleSvc, _GrpTypeSvc,
  _GrpFeeSvc, _GrpTxnSvc, _GrpFinTxnSvc,
  _GrpAtrTypeSvc, _GrpAtrSvc,
  _MemTypeSvc, _MemberSvc,
  _PositionTypeSvc, _PositionSvc, _MemAtrTypeSvc, _MemAtrSvc,
  _MemFeeSvc, _MemTxnSvc,
  main, account, accountoauth, user, stripeRedirect, admin,
  group, grpRole, groupFee, groupTransaction,
  memType, member,
  positionType, position, groupAttributeType, memberAttributeType,
  memberFee, memberTransaction, financialTransaction,
  navbar, sidenav, footer, datetime, fileSave,
  list, form, modal, util, ToastrSvc, stripe,
  ngActivityIndicator, loader, constants
])
  .config(routeConfig)
  .run([
    '$rootScope',
    '$location',
    'AuthSvc',
    function($rootScope, $location, AuthSvc) {
      // Redirect to login if route requires auth and you're not logged in
      $rootScope.$on('$stateChangeStart', function(event, next) {
        AuthSvc.isLoggedIn(function(loggedIn) {
          if(next.authenticate && !loggedIn) {
            $location.path('/login');
          }
        });
      });
    }
  ]);

// eslint-disable-next-line no-undef
angular.element(document)
  .ready(() => {
    // eslint-disable-next-line no-undef
    angular.bootstrap(document, ['georgeApp'], {
      strictDi: true
    });
  });
